import {injectable} from "inversify";
import {Negotiation} from "@/modules/diplomacy/entity";
import {NegotiationStatusEnum} from "@/modules/diplomacy/enums";
import {NegotiationCloserInterface} from "@/modules/diplomacy/interfaces";

@injectable()
export abstract class AbstractNegotiationCloser implements NegotiationCloserInterface {
  abstract shouldRun(negotiation: Negotiation): Promise<boolean>;

  public async can(negotiation: Negotiation) {
    return true;
  }

  public async close(negotiation: Negotiation) {
    if (!negotiation.canBeClosed) {
      throw 'Can not close';
    }

    await this.end(negotiation, NegotiationStatusEnum.CLOSED);
  }

  public async abort(negotiation: Negotiation) {
    await this.end(negotiation, NegotiationStatusEnum.FAILED);
  }

  private async end(negotiation: Negotiation, status: NegotiationStatusEnum) {
    negotiation.status = status;
    await negotiation.save();
  }

  protected async endAllOtherNegotiations(negotiation: Negotiation) {
    // todo needed to close other negotiations?
  }
}
